import React, { Fragment } from "react";
import { Seo, Breadcrumb, ScrollTopBtn } from "../components";
import { HeaderThree, FooterTwo } from "../containers";

export default function TermsAndConditions() {
  return (
    <Fragment>
      <Seo
        title="Terms & Conditions - Tech Ayukta"
        description="Read the Terms & Conditions of Tech Ayukta to understand our service policies, user responsibilities, and legal agreements."
        keywords="Tech Ayukta Terms, Terms and Conditions, Service Policy, User Agreement, Legal"
        canonical="https://www.techayukta.com/terms-and-conditions"
      />

      <HeaderThree />
      <Breadcrumb
        pageName="Terms & Conditions"
        bgImage="/images/breadcumb/breadcumb-bg.jpg"
      />
      <div className="container mx-auto px-6 py-12">
        <h3 className="text-3xl font-bold mt-4 mb-6">Terms & Conditions</h3>
        <p className="mb-4">
          Welcome to <strong>Tech Ayukta</strong>. By accessing or using our
          website and services, you agree to comply with and be bound by the
          following Terms & Conditions.
        </p>

        <h4 className="text-xl font-semibold mt-6 mb-2">1. Use of Services</h4>
        <p className="mb-4">
          Our services are intended for lawful purposes only. You agree not to
          misuse or exploit our platform in any way that could damage, disable,
          or impair our systems.
        </p>

        <h4 className="text-xl font-semibold mt-6 mb-2">
          2. Intellectual Property
        </h4>
        <p className="mb-4">
          All content, designs, logos, and intellectual property on this site
          are the exclusive property of Tech Ayukta. Unauthorized reproduction
          or use of our materials is prohibited.
        </p>

        <h4 className="text-xl font-semibold mt-6 mb-2">
          3. Limitation of Liability
        </h4>
        <p className="mb-4">
          Tech Ayukta is not liable for any direct, indirect, or incidental
          damages resulting from the use of our website, products, or services.
        </p>

        <h4 className="text-xl font-semibold mt-6 mb-2">
          4. User Responsibilities
        </h4>
        <p className="mb-4">
          Users are responsible for providing accurate information and complying
          with applicable laws when using our services.
        </p>

        <h4 className="text-xl font-semibold mt-6 mb-2">
          5. Third-Party Links
        </h4>
        <p className="mb-4">
          Our website may contain links to external websites. We are not
          responsible for the content or privacy practices of third-party sites.
        </p>

        <h4 className="text-xl font-semibold mt-6 mb-2">6. Changes to Terms</h4>
        <p className="mb-4">
          We reserve the right to update or modify these Terms & Conditions at
          any time. Continued use of our website indicates acceptance of the
          updated terms.
        </p>

        <p className="mt-8 text-sm">
          For any queries regarding these Terms & Conditions, please contact us
          at <strong>techsupport@techayukta.com</strong>.
        </p>
      </div>
      <FooterTwo />
      <ScrollTopBtn />
    </Fragment>
  );
}
